import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'

// 需要对应的provider自行添加
const SimpleLayout: React.FC = () => {
  return <Outlet />
}
export default SimpleLayout
